import React, { useRef } from 'react';

const MainTabs = ({ children }) => {
	const navRef = useRef(null);

	const handleClick = (e) => {
		const button = e.target.closest('button');
		const nav = navRef.current;
		if (!button || !nav || !nav.contains(button)) return;

		const { paddingLeft, paddingRight } = getComputedStyle(nav);
		const padLeft = parseFloat(paddingLeft) || 0;
		const padRight = parseFloat(paddingRight) || 0;

		const navRect = nav.getBoundingClientRect();
		const buttonRect = button.getBoundingClientRect();

		const overflowRight = buttonRect.right - (navRect.right - padRight);
		const overflowLeft = (navRect.left + padLeft) - buttonRect.left;

		if (overflowRight > 0) {
			nav.scrollBy({ left: overflowRight + padRight, behavior: 'smooth' });
		} else if (overflowLeft > 0) {
			nav.scrollBy({ left: -(overflowLeft + padLeft), behavior: 'smooth' });
		}
	};

	return (
		<nav className="main-tabs" ref={navRef} onClick={handleClick}>
			{children}
		</nav>
	);
};

export default MainTabs;
